import FileUploadIcon from "@mui/icons-material/FileUpload";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Input,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useApiUrl } from "@refinedev/core";
import { Create, useAutocomplete } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState } from "react";
import { dataProvider } from "rest-data-provider";

const filterOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option: any) => option.name,
});
export const BadgeCreate = () => {
  const { autocompleteProps } = useAutocomplete({
    resource: "badge-type",
    filters: [
      {
        field: "status",
        operator: "eq",
        value: 0,
      },
    ],
  });
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const apiUrl = useApiUrl();
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
    setValue,
    setError,
    watch,
  } = useForm();

  const imageInput = watch("badgeUrl");

  const onChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setIsUploadLoading(true);
      const formData = new FormData();
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      formData.append("uri", file);
      const res = await dataProvider(apiUrl).create({resource:'file', variables:formData})
      setValue("badgeUrl", res.data.rawUploadInfo.uri, {
        shouldValidate: true,
      });
      setImgUrl(res.data.rawUploadInfo.uri);
      setIsUploadLoading(false);
    } catch (error) {
      setError("badgeUrl", { message: "Upload failed. Please try again." });
      setIsUploadLoading(false);
    }
  };
  const dateChangeHandler = (e: any) => {
    setValue("expirationDate", e.format("YYYY-MM-DD"), {
      shouldValidate: true,
    });
  };
  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("code", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.code}
          helperText={(errors as any)?.code?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Code"
          name="code"
        />
        <TextField
          {...register("name", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("description", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.description}
          helperText={(errors as any)?.description?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          name="description"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        <DatePicker
          label="Expiration Date"
          defaultValue={""}
          onChange={dateChangeHandler}
        />
        <TextField
          {...register("rank", {
            required: "This field is required",
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.rank}
          helperText={(errors as any)?.rank?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Rank"
          name="rank"
        />
        <Autocomplete
          {...autocompleteProps}
          getOptionLabel={(item) => item.name}
          isOptionEqualToValue={(option, value) => {
            return (
              value === undefined ||
              option?.id?.toString() === (value?.id ?? value)?.toString()
            );
          }}
          onChange={(event: any, value) => {
            setValue("badgeTypeId", value?.id);
          }}
          placeholder="Select a badge type"
          filterOptions={filterOptions}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Badge Type"
                margin="normal"
                variant="outlined"
                required
              />
            );
          }}
        />
        <Stack
          direction="row"
          gap={4}
          flexWrap="wrap"
          sx={{ marginTop: "16px" }}
        >
          <label htmlFor="images-input">
            <Input
              id="images-input"
              type="file"
              sx={{ display: "none" }}
              onChange={onChangeHandler}
            />
            <input
              id="file"
              {...register("badgeUrl", {
                required: "This field is required",
              })}
              type="hidden"
            />
            <LoadingButton
              loading={isUploadLoading}
              loadingPosition="end"
              endIcon={<FileUploadIcon />}
              variant="contained"
              component="span"
            >
              Upload Badge Image
            </LoadingButton>
            <br />
            {errors.badgeUrl && (
              <Typography variant="caption" color="#fa541c">
                {errors.badgeUrl?.message?.toString()}
              </Typography>
            )}
          </label>
          {imageInput && (
            <Box
              component="img"
              sx={{
                maxWidth: 250,
                maxHeight: 250,
              }}
              src={imgUrl}
              alt="Post image"
            />
          )}
        </Stack>
      </Box>
    </Create>
  );
};
